import rootStore from "csi/state/rootStore";
import { FlexColumn, FormField, MultiSelect, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { MATERIAL_GEOMETRIES, MATERIAL_SIDES, MaterialSide, REQUIRED_LABEL } from "../snapshotUtils";
import { useLocale } from "designSystem/locale";

interface MaterialSettingProps {
	/** by pass the check for material sides and geometry and render the component when creating a new template */
	forceVisible?: boolean;
}

const MaterialSettings = observer(({ forceVisible = false }: MaterialSettingProps) => {
	const { threeDStore } = rootStore;
	const loc = useLocale();
	const store = useSnapshotTemplateStore();
	const { hasBackSide, isU3MFabric, showPrimitiveSelector } = threeDStore?.materialSettingsStore || {};
	const showGeometrySelector = showPrimitiveSelector || forceVisible;
	const showSideSelector = isU3MFabric || forceVisible;
	const MATERIAL_SIDES_INVALID_BACK = MATERIAL_SIDES.map((side) => side.id === MaterialSide.Back ? { ...side, disabled: true, invalid: true } : side);
	const availableMaterialSides = hasBackSide || forceVisible ? MATERIAL_SIDES : MATERIAL_SIDES_INVALID_BACK;
	const {
		selectedMaterialPrimitives,
		selectedMaterialSides,
		setSelectedMaterialSides,
		setSelectedMaterialPrimitives,
	} = store;

	if (!showGeometrySelector && !showSideSelector) {
		return null;
	}

	const hasInvalidMaterialSide = useMemo(() => {
		// check if the selected material sides id match any available material sides id that are invalid
		return selectedMaterialSides.some((side) => availableMaterialSides.some((availableSide) => availableSide.id === side.id && availableSide.invalid));
	}, [availableMaterialSides, selectedMaterialSides]);
	
	const errorMsg = hasInvalidMaterialSide ? loc.resource("3DMaterialSideSelectionInvalidMessage") : "";
	
	return (
		<FlexColumn
			sx={{ 
				height:"auto",
			}}
		>
			{ showSideSelector && (
				<FormField
					control={(
						<MultiSelect
							limitTags={2}
							onChange={setSelectedMaterialSides}
							options={availableMaterialSides}
							placeHolderRes="3DSelectMaterialSide"
							value={selectedMaterialSides}
						/>
					)}
					fullWidth
					invalidMessage={errorMsg}
					label={<Text bold res="3DMaterialSide" />}
					labelPlacement="top"
					required
					sx={REQUIRED_LABEL}
				/>
			)}
			{ showGeometrySelector && (
				<FormField
					control={(
						<MultiSelect
							limitTags={3}
							onChange={setSelectedMaterialPrimitives}
							options={MATERIAL_GEOMETRIES}
							placeHolderRes="3DSelectMaterialPrimitives"
							value={selectedMaterialPrimitives}
						/>
					)}
					fullWidth
					label={<Text bold res="MaterialPrimitives" />}
					labelPlacement="top"
					required
					sx={REQUIRED_LABEL}
				/>
			)}
		</FlexColumn>
	);
});

export default MaterialSettings;
